import { Route, Switch } from "wouter";
import { UserSettingsView } from "./user-settings.view";

export function UserSettingsRoutes() {
  return (
    <Switch>
      <Route path="/" component={UserSettingsView} />
    </Switch>
  );
}
